module.exports = __webpack_public_path__ + "img/sea-1.5d022578.jpg";